import LoadingIcons from 'react-loading-icons';
import { Subscription } from '../../../../types/subscription';
import { useCalculateCurrentSingleProfitCalculationQuery } from '../../../../store/services/api';
import SpcResultView from './SpcResultView';

interface Props {
  subscription: Subscription;
}

const Calculations = ({ subscription }: Props) => {
  const { data: spcResult, isLoading } =
    useCalculateCurrentSingleProfitCalculationQuery(subscription.baseAsset);

  if (isLoading) {
    return (
      <div
        style={{
          flex: 1,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <LoadingIcons.Grid width={60} />
      </div>
    );
  }

  if (!spcResult?.data) {
    return null;
  }

  return (
    <div
      style={{
        flex: 1,
        width: '100%',
        minWidth: 0,
        boxSizing: 'border-box',
      }}
    >
      <SpcResultView data={spcResult.data} />
    </div>
  );
};

export default Calculations;
